export default __webpack_public_path__ + "dc08beda2593deecb965d6477976b508.png";